import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

export const enum PageIdWoofzWoofy {
  HELLO_WOOFY = PageId.HELLO_WOOFY,
  COACH_WOOFY = PageId.COACH_WOOFY,
  CHAT_WOOFY = PageId.CHAT_WOOFY,
  DOG_AGE_WOOFY = PageId.DOG_AGE_WOOFY,
  URGE_WOOFY = PageId.URGE_WOOFY,
  BEHAVIOR_WOOFY = PageId.BEHAVIOR_WOOFY,
  PREPARE_FLOW_WOOFY = PageId.PREPARE_FLOW_WOOFY,
  EMAIL_WOOFY = PageId.EMAIL_WOOFY,
  SUBSCRIPTIONS_WOOFY = PageId.SUBSCRIPTIONS_WOOFY,
  DOWNLOAD_WOOFY = PageId.DOWNLOAD_WOOFY,
  ACCOUNT_WOOFY = PageId.ACCOUNT_WOOFY,
}

type TIdToPageMapWoofzWoofy = Record<PageIdWoofzWoofy, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_WOOFY: TIdToPageMapWoofzWoofy = {
  hello_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/hello/HelloPage').then((m) => ({
        default: m.HelloPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_woofy1/pages/hello/HelloPage'),
  },
  coach_woofy: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_woofy1/pages/coach-selection/CoachSelectionPage'
      ).then((m) => ({
        default: m.CoachSelectionPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_woofy1/pages/coach-selection/CoachSelectionPage'
      ),
  },
  urge_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_woofy1/pages/urge/UrgePage'),
  },
  chat: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/chat/ChatPage').then((m) => ({
        default: m.ChatPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_woofy1/pages/chat/ChatPage'),
  },
  dog_age_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_woofy1/pages/questions/DogAgeQuestion'),
  },
  behavior_woofy: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_woofy1/pages/questions/BehaviorQuestion'
      ).then((m) => ({
        default: m.BehaviorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_woofy1/pages/questions/BehaviorQuestion'),
  },
  prepare_flow_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_woofy1/pages/prepare-flow/PrepareFlow'),
  },
  email_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_woofy1/pages/email/Email'),
  },
  subscriptions_woofy: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_woofy1/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_woofy1/pages/subscriptions/SubscriptionsPage'
      ),
  },
  download_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_woofy1/pages/download-app/DownloadApp'),
  },
  account_woofy: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_woofy1/modules/account/AccountWoofy').then(
        (m) => ({
          default: m.AccountWoofy,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_woofy1/modules/account/AccountWoofy'),
  },
}
